import { render, staticRenderFns } from "./VacantJobDuration.vue?vue&type=template&id=d8abfda6&"
import script from "./VacantJobDuration.vue?vue&type=script&lang=js&"
export * from "./VacantJobDuration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports